import React from "react";
import { Search, Home, Wrench, RefreshCcw, Layers, Sun, PenTool } from "lucide-react";
import { ServiceCard } from "../services/ServiceCard";

const ICONS = [Search, Home, Wrench, RefreshCcw, Layers, Sun, PenTool];

export default function Services({ t }) {
  return (
    <section id="services" data-testid="services-section" className="relative py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="max-w-3xl mb-12 md:mb-16">
          <span className="section-tag" data-testid="services-tag">{t.services.tag}</span>
          <h2
            data-testid="services-title"
            className="font-display font-black text-brand-primary text-3xl sm:text-4xl lg:text-5xl tracking-tighter mt-5 leading-[1.05]"
          >
            {t.services.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-brand-muted leading-relaxed max-w-2xl">{t.services.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-testid="services-grid">
          {t.services.items.map((s, i) => (
            <ServiceCard key={s.name} service={s} index={i} icon={ICONS[i] || Wrench} cta={t.services.cta} />
          ))}
        </div>
      </div>
    </section>
  );
}
